import {Component, EventEmitter, Input} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {IAttribute, IOption} from "../../add-product-form.interface";
import {ProductAddHelperService} from "../../product-add-helper.service";
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-add-product-variants-modal',
    templateUrl: './add-product-variants-modal.component.html',
    styleUrl: './add-product-variants-modal.component.scss',
    standalone: false
})
export class AddProductVariantsModalComponent {
  @Input() variantsForm: FormGroup;
  variantsFormLocal: FormGroup = this._fb.group({
    variants: this._fb.array([])
  });
  @Input() apply: EventEmitter<IOption[]> = new EventEmitter<IOption[]>();
  @Input() activeAttributes: IOption[];
  atts = [];

  constructor(private _fb: FormBuilder,
              private _activeModal: DbActiveModal,
              private _productAddHelper: ProductAddHelperService) {
  }

  private _clearVariantsArray() {
    const variants = this.variantsForm.get('variants') as FormArray;
    while (variants.length !== 0) {
      variants.removeAt(0);
    }
  }

  @Input() set attributes(atts: IAttribute[]) {
    this.atts = atts;
  }

  cancel() {
    this._activeModal.close();
  }

  add() {
    this._clearVariantsArray();
    const {variants} = this.variantsFormLocal.getRawValue();
    const variantsFormArray = this.variantsForm.get('variants') as FormArray;
    variants.map(option => {
      const form = this._productAddHelper.variantFormTemplate();

      form.get('option').setValue(option.option);
      option.option_value.map((value, index) => {
        (form.get('option_value') as FormArray).push(this._fb.group({name: value.name}));
      });
      variantsFormArray.push(form);
    });
    this._activeModal.close();
    this.apply.emit(this.activeAttributes)
  }

}
